module.exports = __webpack_public_path__ + "static/media/icon-settings-crossbeam.756fa5d7.svg";